/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

@classNames('flex-50')
export default class SifSchool extends Component {
  // Props
  // school provides the school record from SIF to be displayed.
  school = null;

  // onAccept is the action which will be triggered when the button within the
  // displayed school is clicked.  Defaults to a noop to prevent errors.
  onAccept() {}

  // accept triggers the provided onAccept function/action when the button is
  // clicked by the user.
  @action
  accept() {
    this.onAccept(this.school);
  }
}
